import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { get } from 'lodash'
import I18n from 'I18n'

ButtonCapacityControl.propTypes = {
  constructorFunctions: PropTypes.object.isRequired,
  withinDropdown: PropTypes.bool
}

export default function ButtonCapacityControl({
  constructorFunctions,
  withinDropdown = false
}) {
  return (
    <Button
      className={withinDropdown ? 'btn-within-dropdown' : ''}
      icon='edit'
      type={withinDropdown ? 'ghost' : ''}
      onClick={e => {
        e.stopPropagation() // necessary to prevent the click event from bubbling up when use in a dropdown's table rown

        get(constructorFunctions, 'askCapacityControl')()
      }}
    >
      {I18n.t('pages.permits.actions.controlCapacity')}
    </Button>
  )
}
